<template>
  <BaseModalEditCreate
    :title="$t('common.actions.add')"
    mode="select"
    :is-modified="false"
    :close-on-outside-click="false"
    max-width="extra"
    @dismiss-changes="emit('close')"
    @save="emitSelectedRows = true">
    <template #form>
      <div class="overflow-hidden h-full grid grid-rows-[auto_1fr]">
        <div class="font-light">{{ $t('messages.info.ctrlClickToAddItems') }}</div>
        <div class="w-full h-full overflow-x-hidden">
          <BaseTable
            v-if="list"
            table-id="pricingPolicy-modal-customers"
            :total-records="totalRecords"
            :headers="customerHeaders"
            :list="list"
            :emit-selected-rows="emitSelectedRows"
            only-search
            hide-multiselect-delete
            hide-multiselect-download
            @refresh-data="onRefreshData"
            @selected-rows="onMultiselect" />
        </div>
      </div>
    </template>
  </BaseModalEditCreate>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import BaseModalEditCreate from '../common/BaseModalEditCreate.vue';
import BaseTable from '../common/BaseTable.vue';
import type { Customer } from '@/types/Traders';
import type { TableFilterData } from '@/types/Base';

const { t: $t } = useI18n({ useScope: 'global' });
const emit = defineEmits(['close', 'refreshData', 'multiSelect']);

const emitSelectedRows = ref(false);

defineProps<{
  list: Customer[];
  totalRecords?: number;
}>();

const customerHeaders = [
  { value: 'code', text: `${$t('baseObject.code')}`, type: 'text', active: true },
  { value: 'profession', text: `${$t('customer.profession')}`, type: 'text', active: true },
  { value: 'trader.name', text: `${$t('customer.traderName')}`, type: 'text', active: true },
  { value: 'trader.code', text: `${$t('customer.traderCode')}`, type: 'text', active: true },
  {
    value: 'trader.taxNumber',
    text: `${$t('customer.traderTaxNumber')}`,
    type: 'text',
    active: true,
  },
  { value: 'trader.address', text: `${$t('address')}`, type: 'text', active: true },
  { value: 'trader.zipCode', text: `${$t('zipCodes')}`, type: 'text', active: true },
  {
    value: 'defaultPaymentType.name',
    text: 'Default Payment Type',
    type: 'text',
    active: true,
  },
];

function onRefreshData(data: TableFilterData) {
  data.sortColumn = data.column ? customerHeaders[data.column].value : '';
  emit('refreshData', data);
}

function onMultiselect(items: Customer[]) {
  emit('multiSelect', items);
}
</script>
